import BasicType from './BasicType';
import moment from 'moment';

export default class PaxTimePeriod implements BasicType {
    public from: moment.Moment;
    public to: moment.Moment;
    public pax: number;

    constructor(from: moment.Moment, to: moment.Moment, pax: number) {
        this.from = from;
        this.to = to;
        this.pax = pax;
    }

    public toString(): string {
        return `from =  ${this.from}, to = ${this.to}, pax = ${this.pax}`;
    }

    equals(other: PaxTimePeriod): boolean {
        return this.from === other.from && this.to === other.to && this.pax === other.pax;
    }

    public static fromJson(json: any): PaxTimePeriod {
        return new PaxTimePeriod(moment(json.from, 'HH:mm'), moment(json.to, 'HH:mm'), json.pax);
    }
}
